export const body = document.getElementsByTagName('body')[0];
